// fonts

//audio
// mp3 files
import mp3_crash from './audio/crash.mp3';
import mp3_explosion from './audio/explosion.mp3';
import mp3_bgm from './audio/bgm_2_cut1.mp3'
import mp3_ignition from './audio/ignition.mp3'
import mp3_missile from './audio/missile.mp3'
import mp3_missile_warning from './audio/missile_warning.mp3'
import mp3_shoot from './audio/shoot.mp3'
import mp3_battle_truck from './audio/battle_truck.mp3';
import mp3_game_over from './audio/game_over.mp3';
import mp3_split_shooter from './audio/split_shooter.mp3';
import mp3_coin from './audio/coin.mp3';

// texture atlas

import asset_data from './images/atlas/HD/HD_assets.json';
import asset_day from './images/atlas/HD/assets_day.json';
import asset_texture_0 from './images/atlas/HD/HD_assets_0.png';
import asset_texture_1 from './images/atlas/HD/HD_assets_1.png';
import asset_texture_2 from './images/atlas/HD/HD_assets_2.png';
import asset_texture_3 from './images/atlas/HD/HD_assets_3.png';
import asset_texture_4 from './images/atlas/HD/HD_assets_4.png';
import asset_texture_5 from './images/atlas/HD/HD_assets_5.png';
import asset_texture_6 from './images/atlas/HD/HD_assets_6.png';

//images
import image_black_bg from './images/UI/black_panel.png';
import image_spinner from './images/UI/spinner.png';
import image_lives from './images/UI/heart.png';
import image_logo from './images/UI/loading.png';

import desert from './images/atlas/HD/desert.png';
import snow from './images/atlas/HD/snow.png';
import colliders from './data/colliders.json';

// cars
import car_01 from './images/UI/cars/car_01.png';
import car_01_shadow from './images/UI/cars/car_01_shadow.png';
import car_01_dead from './images/UI/cars/car_01_dead.png';
import car_02 from './images/UI/cars/car_02.png';
import car_02_shadow from './images/UI/cars/car_02_shadow.png';
import car_02_dead from './images/UI/cars/car_02_dead.png';
import car_03 from './images/UI/cars/car_03.png';
import car_03_shadow from './images/UI/cars/car_03_shadow.png';
import car_03_dead from './images/UI/cars/car_03_dead.png';
import car_04 from './images/UI/cars/car_04.png';
import car_04_shadow from './images/UI/cars/car_04_shadow.png';
import car_04_dead from './images/UI/cars/car_04_dead.png';
import car_05 from './images/UI/cars/car_05.png';
import car_05_shadow from './images/UI/cars/car_05_shadow.png';
import car_05_dead from './images/UI/cars/car_05_dead.png';
import car_06 from './images/UI/cars/car_06.png';
import car_06_shadow from './images/UI/cars/car_06_shadow.png';
import car_06_dead from './images/UI/cars/car_06_dead.png';

// main menu
import invite_friends_button from './images/UI/home/invite_friends_button.png';
import shop_button from './images/UI/home/shop_button.png';
import tournament_button from './images/UI/home/tournament_button.png';
import play_button from './images/UI/home/tap_to_play_button.png';
import how_to_play_button from './images/UI/home/how_to_play_button.png';

// shop
import buy_button from './images/UI/shop/buy_button.png';
import display_panel from './images/UI/shop/display_panel.png';
import equip_button from './images/UI/shop/equip_button.png';
import equipped_button from './images/UI/shop/equipped_button.png';
import insufficient_coins_button from './images/UI/shop/insufficient_coins_button.png';
import next_button from './images/UI/shop/next_button.png';
import price_panel from './images/UI/shop/price_panel.png';
import selected_button from './images/UI/shop/selected_button.png';
import shop_panel from './images/UI/shop/shop_panel.png';
import unselected_button from './images/UI/shop/unselected_button.png';
import health_level from './images/UI/shop/health_level.png';
import health_level_bar from './images/UI/shop/health_level_bar.png';

// tournament
import close_button from './images/UI/tournament/close_button.png';
import exit_button from './images/UI/tournament/exit_button.png';
import friends_button from './images/UI/tournament/friends_button.png';
import players_rank_bg from './images/UI/tournament/players_rank_bg.png';
import replay_button from './images/UI/tournament/replay_button.png';
import share_button from './images/UI/tournament/share_button.png';
import tournament_panel from './images/UI/tournament/tournament_panel.png';
import create_tournament_button from './images/UI/tournament/create_tournament_button.png';

// ad
import ad_no_button from './images/UI/ad_no_button.png';
import ad_yes_button from './images/UI/ad_yes_button.png';
import watch_ad_button from './images/UI/watch_ad_button.png';

// icon
import icon from './images/UI/icon.png';

// how to play
import howtoplay0 from './images/UI/howtoplay1.png';
import howtoplay1 from './images/UI/howtoplay2.png';
import howtoplay2 from './images/UI/howtoplay3.png';
import howtoplay3 from './images/UI/howtoplay4.png';
import howtoplay4 from './images/UI/howtoplay5.png';
import how_to_play_panel from './images/UI/how_to_play_panel.png';

import bg_panel from './images/UI/bg_panel.png';

var assets_load_data = [

    { type: 'image', name: 'bg_panel', url_1: bg_panel },

    { type: 'image', name: 'icon', url_1: icon },

    { type: 'image', name: 'howtoplay0', url_1: howtoplay0 },
    { type: 'image', name: 'howtoplay1', url_1: howtoplay1 },
    { type: 'image', name: 'howtoplay2', url_1: howtoplay2 },
    { type: 'image', name: 'howtoplay3', url_1: howtoplay3 },
    { type: 'image', name: 'howtoplay4', url_1: howtoplay4 },
    { type: 'image', name: 'how_to_play_panel', url_1: how_to_play_panel },

    { type: 'image', name: 'invite_friends_button', url_1: invite_friends_button },
    { type: 'image', name: 'tournament_button', url_1: tournament_button },
    { type: 'image', name: 'shop_button', url_1: shop_button },
    { type: 'image', name: 'play_button', url_1: play_button },
    { type: 'image', name: 'how_to_play_button', url_1: how_to_play_button },

    { type: 'image', name: 'buy_button', url_1: buy_button },
    { type: 'image', name: 'display_panel', url_1: display_panel },
    { type: 'image', name: 'equip_button', url_1: equip_button },
    { type: 'image', name: 'equipped_button', url_1: equipped_button },
    { type: 'image', name: 'insufficient_coins_button', url_1: insufficient_coins_button },
    { type: 'image', name: 'health_level', url_1: health_level },
    { type: 'image', name: 'health_level_bar', url_1: health_level_bar },
    { type: 'image', name: 'next_button', url_1: next_button },
    { type: 'image', name: 'price_panel', url_1: price_panel },
    { type: 'image', name: 'selected_button', url_1: selected_button },
    { type: 'image', name: 'shop_panel', url_1: shop_panel },
    { type: 'image', name: 'unselected_button', url_1: unselected_button },

    { type: 'image', name: 'close_button', url_1: close_button },
    { type: 'image', name: 'exit_button', url_1: exit_button },
    { type: 'image', name: 'friends_button', url_1: friends_button },
    { type: 'image', name: 'players_rank_bg', url_1: players_rank_bg },
    { type: 'image', name: 'replay_button', url_1: replay_button },
    { type: 'image', name: 'share_button', url_1: share_button },
    { type: 'image', name: 'tournament_panel', url_1: tournament_panel },
    { type: 'image', name: 'create_tournament_button', url_1: create_tournament_button },

    { type: 'image', name: 'car_01', url_1: car_01 },
    { type: 'image', name: 'car_01_shadow', url_1: car_01_shadow },
    { type: 'image', name: 'car_01_dead', url_1: car_01_dead },
    { type: 'image', name: 'car_02', url_1: car_03 },
    { type: 'image', name: 'car_02_shadow', url_1: car_03_shadow },
    { type: 'image', name: 'car_02_dead', url_1: car_03_dead },
    { type: 'image', name: 'car_03', url_1: car_02 },
    { type: 'image', name: 'car_03_shadow', url_1: car_02_shadow },
    { type: 'image', name: 'car_03_dead', url_1: car_02_dead },
    { type: 'image', name: 'car_04', url_1: car_05 },
    { type: 'image', name: 'car_04_shadow', url_1: car_05_shadow },
    { type: 'image', name: 'car_04_dead', url_1: car_05_dead },
    { type: 'image', name: 'car_05', url_1: car_04 },
    { type: 'image', name: 'car_05_shadow', url_1: car_04_shadow },
    { type: 'image', name: 'car_05_dead', url_1: car_04_dead },
    { type: 'image', name: 'car_06', url_1: car_06 },
    { type: 'image', name: 'car_06_shadow', url_1: car_06_shadow },
    { type: 'image', name: 'car_06_dead', url_1: car_06_dead },

    { type: 'image', name: 'ad_yes_button', url_1: ad_yes_button },
    { type: 'image', name: 'ad_no_button', url_1: ad_no_button },
    { type: 'image', name: 'watch_ad_button', url_1: watch_ad_button },

    { type: 'image', name: 'black_panel', url_1: image_black_bg },
    { type: 'image', name: 'spinner', url_1: image_spinner },
    { type: 'image', name: 'lives', url_1: image_lives },
    { type: 'image', name: 'logo', url_1: image_logo },

    { type: "audio", name: "explosion", url_1: mp3_explosion, },
    { type: "audio", name: "crash", url_1: mp3_crash, },
    { type: 'audio', name: 'bgm', url_1: mp3_bgm, },
    { type: 'audio', name: 'ignition', url_1: mp3_ignition, },
    { type: 'audio', name: 'missile', url_1: mp3_missile, },
    { type: 'audio', name: 'missile_warning', url_1: mp3_missile_warning, },
    { type: 'audio', name: 'shoot', url_1: mp3_shoot, },
    { type: 'audio', name: 'battle_truck', url_1: mp3_battle_truck, },
    { type: 'audio', name: 'game_over', url_1: mp3_game_over, },
    { type: 'audio', name: 'split_shooter', url_1: mp3_split_shooter, },
    { type: 'audio', name: 'coin', url_1: mp3_coin, },

    { type: 'atlas', name: 'assets', data_1: asset_data, texture_1: [asset_texture_0, asset_texture_1, asset_texture_2, asset_texture_3, asset_texture_4] }, //  
    { type: 'json', name: "colliders", url: colliders },

    { type: 'image', name: 'desert', url_1: desert, },
    { type: 'image', name: 'snow', url_1: snow, },

    { type: 'atlas', name: 'assets', data_1: asset_data, texture_1: [asset_texture_0, asset_texture_1, asset_texture_2, asset_texture_3, asset_texture_4, asset_texture_5] }, //  
    { type: 'atlas', name: 'assets_day', data_1: asset_day, texture_1: [asset_texture_6] },
]

export default assets_load_data;

